import { render, staticRenderFns } from "./v32.vue?vue&type=template&id=5c21bf34&scoped=true&"
import script from "./v32.vue?vue&type=script&lang=js&"
export * from "./v32.vue?vue&type=script&lang=js&"
import style0 from "./v32.vue?vue&type=style&index=0&id=5c21bf34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c21bf34",
  null
  
)

export default component.exports